import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useT } from 'talkr';
import store from '../../store';
import s from './index.module.scss';

function ProgressBarV3() {
  const { T } = useT();
  const currentStepIndex = useSelector((state) => state.steps.currentStepIndex);

  const { currentStep } = store.getState().steps;
  const [progress, setProgress] = useState(0);
  const [title, setTitle] = useState(T('customV2_progress_text1'));
  
  useEffect(() => {
    let progressValue = 0;
    if (currentStepIndex === 2) {
      progressValue = 4;
    }
    if (currentStepIndex === 3) {
      progressValue = 8;
    }
    if (currentStepIndex === 4) {
      progressValue = 12;
    }
    if (currentStepIndex === 5) {
      progressValue = 16;
    }
    if (currentStepIndex === 6) {
      progressValue = 20;
    }
    if (currentStepIndex === 7) {
      progressValue = 22;
    }
    if (currentStepIndex === 8) {
      progressValue = 26;
    }

    if (currentStepIndex === 9) {
      progressValue = 30;
    }
    if (currentStepIndex === 10) {
      progressValue = 33;
    }
    if (currentStepIndex === 11) {
      progressValue = 36;
    }
    if (currentStepIndex === 12) {
      progressValue = 39;
    }
    if (currentStepIndex === 13) {
      progressValue = 41;
    }
    if (currentStepIndex === 14) {
      progressValue = 44;
    }
    if (currentStepIndex === 15) {
      progressValue = 47;
    }
    if (currentStepIndex === 16) {
      progressValue = 50;
    }

    if (currentStepIndex === 17) {
      progressValue = 53;
    }
    if (currentStepIndex === 18) {
      progressValue = 57;
    }
    if (currentStepIndex === 19) {
      progressValue = 61;
    }
    if (currentStepIndex === 20) {
      progressValue = 65;
    }
    if (currentStepIndex === 21) {
      progressValue = 70;
    }
    if (currentStepIndex === 22) {
      progressValue = 73;
    }

    if (currentStepIndex === 23) {
      progressValue = 77;
    }
    if (currentStepIndex === 24) {
      progressValue = 80;
    }
    if (currentStepIndex === 25) {
      progressValue = 83;
    }
    if (currentStepIndex === 26) {
      progressValue = 86;
    }
    if (currentStepIndex === 27) {
      progressValue = 89;
    }
    if (currentStepIndex === 28) {
      progressValue = 91;
    }
    if (currentStepIndex === 29) {
      progressValue = 94;
    }
    if (currentStepIndex === 30) {
      progressValue = 98;
    }
  
    if (currentStepIndex < 9 && title !== T('customV2_progress_text1')) {
      setTitle(T('customV2_progress_text1'));
    }
    if (currentStepIndex >= 9 && currentStepIndex <= 16 && title !== T('customV2_progress_text2')) {
      setTitle(T('customV2_progress_text2'));
    }
    if (currentStepIndex > 16 && currentStepIndex <= 22 && title !== T('customV2_progress_text4')) {
      setTitle(T('customV2_progress_text4'));
    }
    if (currentStepIndex > 22 && title !== T('customV2_progress_text3')) {
      setTitle(T('customV2_progress_text3'));
    }

    setProgress(-100 + progressValue);
  }, [currentStep]);

  return (
    <div className={s.progressBarWrapper}>
      <p className={s.progressBarText}>{title}</p>
      <div className={s.progressBlock}>
        <div
          className={`${s.progressBar}`}
          style={{
            transform: `translateX(${progress}%)`,
          }}
        />
        <div className={s.progressBarDividers}>
          <div className={s.progressBarDivider} />
          <div className={s.progressBarDivider} />
          <div className={s.progressBarDivider} />
          <div className={s.progressBarDivider} />
          <div className={s.progressBarDivider} />
        </div>
        <div className={s.progressBarLines}>
          <div className={s.progressBarLine} />
          <div className={s.progressBarLine} />
          <div className={s.progressBarLine} />
          <div className={s.progressBarLine} />
        </div>
      </div>
    </div>
  );
}

export default ProgressBarV3;
